export default async (endpoint, file, onProgress, noPii = false) =>
  new Promise((resolve, reject) => {
    const request = new XMLHttpRequest();
    // S3 upload buckets allow deployed OnPoint origins, but not localhost. Route only
    // local development uploads through the local API proxy; deployed builds still
    // upload directly to the presigned URL.
    // eslint-disable-next-line no-restricted-globals
    const isLocal = location.hostname === 'localhost';
    const uploadEndpoint = isLocal
      ? `${process.env.REACT_APP_ONPOINT || 'http://localhost'}/local-presigned-upload`
      : endpoint;

    request.open(isLocal ? 'POST' : 'PUT', uploadEndpoint, true);

    request.onreadystatechange = () => {
      if (request.readyState !== XMLHttpRequest.DONE) {
        return;
      }

      if (request.status <= 299) {
        resolve(request.status);
      } else {
        const body = request.responseText || '';
        const code = (body.match(/<Code>([^<]+)<\/Code>/) || [])[1];
        const detail = (body.match(/<Message>([^<]+)<\/Message>/) || [])[1];
        reject(new Error([code, detail].filter(Boolean).join(': ') || `Upload failed (${request.status})`));
      }
    };

    request.onabort = () => {
      reject(new Error('Request is aborted'));
    };

    request.onerror = () => {
      reject(new Error('Network Error'));
    };

    request.ontimeout = () => {
      reject(new Error('Timeout Error'));
    };

    // Set headers
    if (isLocal) {
      request.setRequestHeader('x-presigned-url', endpoint);
      request.setRequestHeader('x-upload-no-pii', noPii ? 'true' : 'false');
    } else if (!noPii) {
      request.setRequestHeader('x-amz-acl', 'bucket-owner-full-control');
    }
    request.setRequestHeader('Content-Type', 'application/octet-stream');
    const signedHeaders = new URL(endpoint).searchParams.get('X-Amz-SignedHeaders') || '';
    const signatureRequiresEncryption = signedHeaders.split(';').includes('x-amz-server-side-encryption');
    if (!isLocal && signatureRequiresEncryption) {
      request.setRequestHeader('x-amz-server-side-encryption', 'aws:kms');
      request.setRequestHeader(
        'x-amz-server-side-encryption-aws-kms-key-id',
        `arn:aws:kms:us-west-2:${noPii ? '031694100406' : '558766445240'}:alias/aws/s3`
      );
    }

    if (onProgress) {
      request.upload.addEventListener('progress', (event) => {
        const ratio = Math.ceil((event.loaded / event.total) * 100);
        onProgress(ratio);
      });
    }

    request.send(file);
  });
